import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark",
  style: {"margin-bottom":"0"}
}
const _hoisted_2 = {
  class: "collapse navbar-collapse",
  id: "AdminNavigation"
}
const _hoisted_3 = { class: "navbar-nav mr-auto" }
const _hoisted_4 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_5 = { class: "navbar-brand" }
const _hoisted_6 = { class: "navbar-brand" }
const _hoisted_7 = { class: "navbar-brand" }
const _hoisted_8 = { class: "navbar-brand" }
const _hoisted_9 = { class: "navbar-brand" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminNavigationV2',
  props: {
    tid: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("button", {
      class: "navbar-toggler",
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#AdminNavigation"
    }, [
      _createElementVNode("span", { class: "navbar-toggler-icon" })
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (__props.tid)
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Dashboard", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, `/#/admin/organizations/dashboard/${__props.tid}`]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Users", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, `/#/admin/organizations/users/active/${__props.tid}`]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Workspaces", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, `/#/admin/organizations/workspaces/${__props.tid}`]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_8, [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Shares", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, `/#/sharing/admin/activeshares/${__props.tid}`]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_9, [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Integrations", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, `/#/admin/integrations/pipelines/dashboard/${__props.tid}`]
              ]),
              _createCommentVNode("<a class=\"navbar-brand\" v-sanitizedHref=\"`/#/admin/portfolios/${tid}`\">Portfolios</a>")
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _cache[5] || (_cache[5] = _createStaticVNode("<ul class=\"navbar-nav\"><li class=\"nav-item dropdown\"><a class=\"nav-link dropdown-toggle\" data-toggle=\"dropdown\"> Account </a><div class=\"dropdown-menu dropdown-menu-right\"><a class=\"dropdown-item\" href=\"/#/organizations/users/dashboard\">My dashboard</a><a class=\"dropdown-item\" href=\"/#/organizations/users/account\">Manage your account</a><div class=\"dropdown-divider\"></div><a class=\"dropdown-item\" href=\"/organizations/sessions/close\">Sign out</a></div></li></ul>", 1))
    ])
  ]))
}
}

})